/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2021
	12-03-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_pdf.onready();

	
!Wishlist

	none
	
*/
  
var specific_pdf = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none

	this.onready = function() {

	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
		
	/*
	Render
	*/
	this.render = function(
		which,
		id
	) {

		if(which == 'deliveryform') {

			/*
			Render and save
			*/
			$.ajax({
				url: globalUrl + '/a/a/pdf-save-' + which,
				type: "POST",
				data: {
					id	: $('.js-' + which + '-id').val(),
					project_id: $('.js-project-id').val()
				},
				headers: { 
					'go-load':1 
				}
			})
			.done(function(data) {

				/*
				Progress to 50%
				*/
				//setTimeout(function() {
					$('.js-progress-done').animate({
						'width':'50%'
					},2000);

					/*
					Send
					*/
					specific_pdf.send(
						which,
						$('.js-' + which + '-id').val()
					);

				//},1000);

			})
			.always(function() {
			});

		} else {

			/*
			Render and save
			*/
			$.ajax({
				url: globalUrl + '/a/a/pdf-save-' + which,
				type: "POST",
				data: {
					id	: $('.js-' + which + '-id').val()
				},
				headers: { 
					'go-load':1 
				}
			})
			.done(function(data) {

				/*
				Progress to 50%
				*/
				//setTimeout(function() {
					$('.js-progress-done').animate({
						'width':'50%'
					},2000);

					/*
					Send
					*/
					specific_pdf.send(
						which,
						$('.js-' + which + '-id').val()
					);

				//},1000);

			})
			.always(function() {
			});

		}
		
	};	

	/*
	Send
	*/
	this.send = function(
		which,
		id
	) {

		var _send_to_client = $('.js-checkbox-send-client').hasClass('active');
		var _send_to_office = $('.js-checkbox-send-office').hasClass('active');

		/*
		Send
		*/
		$.ajax({
			url: globalUrl + '/a/a/pdf-send-' + which,
			type: "POST",
			data: {
				id: id,
				send_to_client: _send_to_client,
				send_to_office: _send_to_office
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Progress to 50%
			*/
			//setTimeout(function() {
				$('.js-progress-done').animate({
					'width':'100%'
				},500,function() {

					specific_pdf.done();
					//specific_pdf.resetSignatures(which);

				});
			//},2000);

		})
		.always(function() {
		});

	};

	/*
	Done: Sending
	*/
	this.done = function() {

		$('.js-popup-pdf-loader').hide();
		$('.js-popup-pdf-done').show();

	};

	/*
	Signatures: Reset and delete
	*/
	// this.resetSignatures = function(which) {

	// 	//alert('Handtekeningen wissen?? (' + which + ')');

	// };
		
}).apply(specific_pdf); 